{
  "amount_to_pay": "Te betalen bedrag",
  "booking_number": "Boekingsnummer",
  "deposit": "Nu te betalen bedrag (aanbetaling)",
  "description": "Ga verder met de betaling om je boeking te bevestigen.",
  "estimated_amount_in_dollars": "USD-equivalent gebaseerd op de wisselkoers van vandaag",
  "full_amount": "Volledig bedrag",
  "generic_error": "Er is een probleem opgetreden met de betaling. Neem contact op met uw creditcardmaatschappij of bank voordat u het opnieuw probeert.",
  "interac": {
    "title": "Interac-instructies",
    "description": "Verstuur een Interac e-Transfer vanuit de online of mobiele bankieromgeving van je Canadese bank. Zodra we de overboeking ontvangen, bevestigen we je boeking.",
    "converted_at": "Omgerekend tegen {{eur}} ≈ {{cad}} — koers vast tot {{valid_until}}",
    "quote_validity": "Deze koers is <strong>5 dagen</strong> geldig — tot {{valid_until}}. Daarna wordt het CAD-bedrag opnieuw berekend op basis van de actuele koers.",
    "contact": "Vragen? Mail naar <a class=\"underline text-primary\" href=\"{{href}}\">info@boatbiketours.com</a>",
    "copy": "Kopiëren",
    "sent": "Ik heb de e-Transfer verstuurd",
    "steps": {
      "recipient": {
        "title": "Versturen naar (e-mailadres)",
        "hint": "Voeg dit toe als begunstigde in je online bankieren."
      },
      "amount": {
        "title": "Bedrag",
        "hint": "Stuur exact dit bedrag. Andere bedragen vertragen de bevestiging."
      },
      "reference": {
        "title": "Referentie / Bericht",
        "hint": "Plak dit in het berichtveld zodat we de betaling aan je boeking kunnen koppelen."
      }
    }
  },
  "local_costs": "Lokale kosten (te betalen aan boord bij vertrek)",
  "methods": {
    "interac": {
      "title": "Betaal in CAD",
      "description": "e-Transfer met Interac",
      "badge": "NIEUW · CA"
    },
    "card": {
      "title": "Betaal in USD",
      "description": "Creditcard of ACH"
    }
  },
  "safe_secure_checkout": "Gegarandeerd <1>veilig & beveiligd</1> afrekenen",
  "powered_by_stripe": "Mogelijk gemaakt door Stripe",
  "paid_amount_in_dollars": "Betaald bedrag in USD",
  "pay_deposit": "Aanbetaling doen",
  "pay_full_amount": "Betaal het volledige bedrag",
  "payment_completed_title": "Bedankt voor uw betaling",
  "payment_completed_description_deposit": "Uw aanbetaling is ontvangen.",
  "payment_completed_description_full": "Uw volledige betaling is ontvangen.",
  "payment_completed_description_interac": "Uw betaling is onderweg. Zodra uw Interac e-Transfer is ontvangen, sturen we u een bevestigingsmail.",
  "payment_description": "Ga verder met de betaling voor uw boeking.",
  "payment_status": "Betalingsstatus",
  "payment_title": "Voldoe uw uitstaande betaling",
  "processing_message": "De betaling heeft momenteel de status ‘Processing’. Het kan 4-5 werkdagen duren voordat deze is gekoppeld aan je boeking. Je ontvangt daarna een betalingsbevestiging en je boekingsbevestiging.",
  "retry": "Opnieuw proberen",
  "status": {
    "canceled": "Niet gelukt",
    "processing": "Verwerken",
    "succeeded": "Geslaagd"
  },
  "title": "Bedankt voor uw boeking!",
  "total_amount": "Gehele boekingsbedrag"
}
